import { Capacitor } from "@capacitor/core";
import type { ClientKind, Platform } from "./types";
import { webDevice } from "./device.web";
import { nativeDevice } from "./device.native";
import { webAuth } from "./auth.web";
import { nativeAuth } from "./auth.native";
import { withMocks } from "./authMock";
import { webBrowser } from "./browser.web";
import { nativeBrowser } from "./browser.native";
import { webApp } from "./app.web";
import { nativeApp } from "./app.native";
import { createMockBilling, isMockBilling, webBilling } from "./billing";
import { nativeBilling } from "./billing.native";
import { webAnalytics } from "./analytics.web";
import { nativeAnalytics } from "./analytics.native";
import { webUpdater } from "./updater.web";
import { nativeUpdater } from "./updater.native";
import { webPush } from "./push.web";
import { nativePush } from "./push.native";

export type {
  AnalyticsPort,
  AppInfo,
  AppleSignInResult,
  AppPort,
  AuthError,
  AuthErrorCode,
  AuthPort,
  BillingError,
  BillingErrorCode,
  BillingPort,
  BrowserPort,
  ClientKind,
  CommonProps,
  DeviceInfo,
  DevicePort,
  Platform,
  PurchaseResult,
  PushPermission,
  PushPort,
  SecureStore,
  ShareResult,
  OtaCheck,
  OtaUpdate,
  UpdaterPort,
} from "./types";
export { SECURE_KEY_REFRESH_TOKEN, isAuthError, isBillingError } from "./types";

function detectClientKind(): ClientKind {
  if (!Capacitor.isNativePlatform()) return "web";
  return Capacitor.getPlatform() === "ios" ? "ios" : "android";
}

const clientKind = detectClientKind();
// AC0-227·AC0-302: 모의 결제(앱·웹)는 로컬 빌드 전용, 스테이지 빌드는 항상 실결제
const useMockBilling = isMockBilling(import.meta.env);

/** 런타임별 어댑터 하나. 화면 코드는 이 객체만 보고 플러그인을 직접 import하지 않는다. 로그인 mock은 제공자별(authMock). */
export const platform: Platform =
  clientKind === "web"
    ? { clientKind, device: webDevice, auth: withMocks(webAuth), browser: webBrowser, app: webApp, billing: useMockBilling ? createMockBilling(clientKind) : webBilling, analytics: webAnalytics, updater: webUpdater, push: webPush }
    : { clientKind, device: nativeDevice, auth: withMocks(nativeAuth), browser: nativeBrowser, app: nativeApp, billing: useMockBilling ? createMockBilling(clientKind) : nativeBilling, analytics: nativeAnalytics, updater: nativeUpdater, push: nativePush };
